<template>
  <div>
    <div>
    </div>
    1
  </div>
</template>

<script>
export default {
  name: 'DisplayPage',
  components: {  },
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/DisplayPage.vue